import React from 'react';
import AdminLoginForm from '../components/admin/AdminLoginForm';

export default function AdminLoginPage() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      <AdminLoginForm />
    </div>
  );
}